import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { NOTE_TYPE_SSE } from "constants/dbValues";
import { title, List } from "utils";

import { Header } from "components";
import { Button, Switch, Icon } from "antd";

class SseListPage extends Component {
  constructor(props) {
    super(props);

    const { type } = this.props;
    let cardsSSE = localStorage.getItem("sse[cards]");

    this.state = {
      cards: type === NOTE_TYPE_SSE ? (!cardsSSE ? true : cardsSSE === "true") : false,
    };

    this.toggleGallery = this.toggleGallery.bind(this);
  }

  toggleGallery() {
    localStorage.setItem("sse[cards]", !this.state.cards);
    this.setState({ cards: !this.state.cards });
  }

  render() {
    const bread = [{ text: "Liste des non-conformités" }];
    const { type } = this.props;

    const filters = type ? { type_id: type } : { type_id_excluded: NOTE_TYPE_SSE };
    const typeString = (type) => {
      if (type === NOTE_TYPE_SSE) return { abbr: "sse", term: "Interventions SSE" };
      return { abbr: "notes", term: "Non-conformités" };
    };
    return (
      <Fragment>
        <Helmet>{title("Liste des interventions SSE")}</Helmet>

        <div className="note-list-page main-content">
          <Header title={typeString(type).term} bread={bread} />

          {type === NOTE_TYPE_SSE && (
            <div className="toggler-wrap">
              <Switch
                checked={this.state.cards}
                onChange={this.toggleGallery}
                checkedChildren={<Icon type="appstore" />}
                unCheckedChildren={<Icon type="table" />}
              />
            </div>
          )}

          <List type={typeString(type).abbr} filters={filters} cards={this.state.cards} />
        </div>
      </Fragment>
    );
  }
}

export default SseListPage;
